import { Component, Input, input, OnInit } from '@angular/core';
import { AppSessionStorageService } from 'src/app/services/utils/session-storage.service';
import { Router } from '@angular/router';
import { AuthserviceService } from 'src/app/services/authservice.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-side-bar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './side-bar.component.html',
  styleUrl: './side-bar.component.css'
})
export class SideBarComponent implements OnInit{

  isDashBoard = AppSessionStorageService.sideBarSelection === 1
  isSettings = AppSessionStorageService.sideBarSelection === 2
  constructor(
    private router: Router,
    private authService:AuthserviceService
  ){}

  ngOnInit(): void {
    this.isDashBoard = AppSessionStorageService.sideBarSelection === 1
    this.isSettings = AppSessionStorageService.sideBarSelection === 2
    this.getUserdetails()
  }

  backToDashboard(){
    if(AppSessionStorageService?.auth?.role == 'installer'){
      this.router.navigate(['installer']);
    }else if(AppSessionStorageService?.auth?.role == 'administrator'){
      this.router.navigate(['admin']);
    }
  }

  profileView(){
    AppSessionStorageService.grantAccess = null;
    if(AppSessionStorageService?.auth?.role == 'installer'){
      this.router.navigate(['installer/profile']);
    }else if(AppSessionStorageService?.auth?.role == 'administrator'){
      this.router.navigate(['admin/profile']);
    }
  }

  logout() {
    this.authService.logout();
  }

  async getUserdetails():Promise<void>{
    this.authService.fetchUserDetails()

  }

}
